module.exports = __webpack_public_path__ + "img/digital_card_bohinj_footer_summer.0252f510.png";